<template>
    <div class="CenteredContent">
        <h1 class="title">What times of the day are you most free?</h1>
        <h5 class="intro"> Please select the time slots that you are likely available. We will send you an email to book the
            exact time. </h5>
            <a-alert v-if="error" type="error" message="You may not select more than 5 time slot" banner />
        <a-checkbox-group @change="changeTime" :defaultValue="defaultValue">
            <div class="box">
                <div class="col" v-for="each,key in week" :key="key">
                    <h6>{{ each }}</h6>
                    <a-checkbox :value="each+key" v-for="v,key in time" :key="key+v">{{ v }}</a-checkbox>
                </div>
            </div>
        </a-checkbox-group>
        <a-button size="large" :disabled="checked.length == 0 || error" type="primary" html-type="submit" @click="handleNext">Next Step</a-button>
    </div>
</template>

<script>
export default {
    props: ['handleTime','defaultValue'],
    data() {
        return {
            week: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            time: ["Morning", "Afternoon", "Night"],
            checked:[],
        }
    },
    computed: {
        error() {
            return this.checked.length > 5
        } 
    },
    methods: {
        changeTime(v) {
            this.checked = v
        },
        handleNext() {
            this.handleTime(this.checked)
        }
    }
}
</script>

<style lang="less" scoped>
.CenteredContent {
    padding: 6.25rem 5rem;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        font-family: auto;
        text-align: center;
    }

    .intro {
        text-align: center;
    }
    .box {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 5rem;
        max-width: 700px;
        margin-bottom: 5rem;
        justify-content: center;
        align-items: center;
        .col {
            display: flex;
            flex-direction: column;

            h6 {
                font-size: 1.7rem;
            }
            .ant-checkbox-wrapper + .ant-checkbox-wrapper {
                margin-left: 0px;
            }
        }
    }
}
</style>